/**
 * Financial calculation utilities
 */

/**
 * Converts an annual CAE (Costo Anual Equivalente) to a monthly rate
 * @param cae Annual CAE as a percentage (e.g., 13.1 for 13.1%)
 * @returns Monthly rate as a decimal
 */
export const convertCAEtoMonthlyRate = (cae: number): number => {
  return cae / 100 / 12;
};

/**
 * Calculates the monthly payment for a loan
 * @param rate Monthly interest rate as a decimal
 * @param amount Loan amount
 * @param term Number of months
 * @returns Monthly payment amount
 */
export const calculateMonthlyPayment = (rate: number, amount: number, term: number): number => {
  if (amount > 0 && term > 0) {
    return (amount * rate) / (1 - (1 + rate) ** -term);
  }
  return 0;
};

/**
 * Calculates the present value (current balance) of a loan
 * @param nper Number of periods (months)
 * @param pmt Monthly payment amount
 * @param monthlyRate Monthly interest rate as a decimal
 * @returns Present value (current balance)
 */
export const calculatePresentValue = (nper: number, pmt: number, monthlyRate: number): number => {
  return (pmt * (1 - (1 + monthlyRate) ** -nper)) / monthlyRate;
};

// Common interest rates
export const INTEREST_RATES = {
  EXCLUSIVE_CAE: 13.1,
  NON_EXCLUSIVE_CAE: 14.3,
  OLD_CAE: 26,
} as const;
